// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledUiAccordion = styled('div')(
  () => css`
    .ui-accordion {
      font-size: 0.75rem;
      line-height: 1.5rem;
      font-weight: 700;

      .MuiAccordion-root {
        border-bottom: 1px solid #cecece;

        &::before {
          content: unset !important;
        }
      }

      .MuiAccordionSummary-content {
        font-size: 0.87rem;
      }

      .icon {
        font-weight: 400;
      }

      .MuiAccordionSummary-root {
        width: 100% !important;
      }

      .accordion-image {
        max-width: 100%;
        margin: 0.5rem 0 0;
      }
    }
  `
);
